import { SVGProps } from "react"

const ParticipantsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    {...props}
  >
    <path
      d="M10.383 8.62874C10.766 8.62874 11.1453 8.5533 11.4991 8.40673C11.853 8.26015 12.1745 8.04531 12.4454 7.77447C12.7162 7.50363 12.931 7.1821 13.0776 6.82824C13.2242 6.47437 13.2996 6.0951 13.2996 5.71208C13.2996 5.32905 13.2242 4.94978 13.0776 4.59592C12.931 4.24205 12.7162 3.92052 12.4454 3.64968C12.1745 3.37884 11.853 3.164 11.4991 3.01743C11.1453 2.87085 10.766 2.79541 10.383 2.79541C9.60943 2.79541 8.86756 3.1027 8.32058 3.64968C7.7736 4.19666 7.46631 4.93853 7.46631 5.71208C7.46631 6.48563 7.7736 7.22749 8.32058 7.77447C8.86756 8.32145 9.60943 8.62874 10.383 8.62874V8.62874Z"
      stroke="#6B7280"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.38271 3.31787C4.9827 3.59564 4.65866 3.9692 4.44019 4.40443C4.22171 4.83967 4.11575 5.3227 4.13199 5.80942C4.14824 6.29614 4.28616 6.77103 4.53317 7.19073C4.78018 7.61043 5.12841 7.96155 5.54604 8.21204"
      stroke="#6B7280"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3828 3.31787C15.769 3.5864 16.0843 3.94443 16.302 4.36135C16.5197 4.77828 16.6332 5.24171 16.6328 5.71204C16.6328 6.70287 16.1386 7.5787 15.3828 8.10537"
      stroke="#6B7280"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.38281 16.9619V17.7952H15.3828V16.9619C15.3828 15.4086 15.3828 14.6319 15.1286 14.0202C14.7905 13.2035 14.1419 12.5546 13.3253 12.2161C12.7128 11.9619 11.9361 11.9619 10.3828 11.9619C8.82948 11.9619 8.05281 11.9619 7.44115 12.2161C7.0366 12.3834 6.66898 12.6288 6.35927 12.9382C6.04957 13.2476 5.80385 13.615 5.63615 14.0194C5.38281 14.6319 5.38281 15.4086 5.38281 16.9619Z"
      stroke="#6B7280"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.716 17.7955V17.2955C18.716 15.4289 18.716 14.4955 18.3527 13.7822C18.0332 13.1547 17.5233 12.6445 16.896 12.3247"
      stroke="#6B7280"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.04932 17.7955V17.2955C2.04932 15.4289 2.04932 14.4955 2.41265 13.7822C2.73208 13.1547 3.24201 12.6445 3.86932 12.3247"
      stroke="#6B7280"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ParticipantsIcon
